import "@mantine/core/styles.css";
import "./assets/fonts/font.css";
import i18n from "../src/config/localization";

import { lazy, Suspense } from "react";
import { MantineProvider } from "@mantine/core";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";

import theme from "./config/theme";
import Router from "./config/routes";
import store from "config/redux/index";
import { ScrollToTop } from "components";

const Banner = lazy(() => import("components/banner"));
const PixelPageTracker = lazy(() => import("components/pixel-tracker"));
const NotificationsProvider = lazy(() => import("components/notifications"));

function App() {
  return (
    <Provider store={store}>
      <MantineProvider theme={theme}>
        <I18nextProvider i18n={i18n}>
          <Suspense fallback={null}>
            <NotificationsProvider />
            <ScrollToTop />
            <Banner />
            <PixelPageTracker />
          </Suspense>
          <Router />
        </I18nextProvider>
      </MantineProvider>
    </Provider>
  );
}

export default App;
